import type { ChatMessage, MessageSummary } from "@/types";

export function completeReviewedMessages(
  messages: ChatMessage[],
  review:
    | { kind: "intake"; batchId: string }
    | { kind: "conversation"; messageId: number },
  summary?: MessageSummary,
): ChatMessage[] {
  const outstanding =
    (summary?.remaining ?? 0) +
    (summary?.failed ?? 0) +
    (summary?.uncertain ?? 0);
  return messages.map((message) => {
    if (
      review.kind === "intake" &&
      message.reviewBatch?.batchId === review.batchId
    ) {
      return {
        ...message,
        reviewBatch:
          outstanding > 0
            ? { ...message.reviewBatch, recordCount: outstanding }
            : undefined,
      };
    }
    if (
      review.kind === "conversation" &&
      message.pendingEmission?.messageId === review.messageId
    ) {
      return { ...message, pendingEmission: undefined };
    }
    return message;
  });
}
